import { firebaseApp, db } from '@/helpers/firebase';
import { BizventoService } from '@bizvento/sdk';

const bizvento = new BizventoService(firebaseApp, db);

export default bizvento;
